module.exports = __webpack_public_path__ + "static/media/location-maps-letter-j.9cb7de21.png";